(() => {
  const widget = document.getElementById('ss-a11y-widget');
  if (!widget || widget.dataset.ready === 'true') return;
  widget.dataset.ready = 'true';

  const root = document.documentElement;
  const panel = widget.querySelector('#ss-a11y-panel');
  const trigger = widget.querySelector('.ss-a11y-trigger');
  const closeButton = widget.querySelector('.ss-a11y-close');
  const resetButton = widget.querySelector('.ss-a11y-reset');
  const liveRegion = widget.querySelector('#ss-a11y-live');
  const settingButtons = [...widget.querySelectorAll('[data-ss-a11y-setting]')];
  const storageKey = 'ss-a11y-preferences-v1';
  const defaults = { text: false, contrast: false, links: false, font: false, motion: false, focus: false };
  const classNames = {
    text: 'ss-a11y-text-large',
    contrast: 'ss-a11y-high-contrast',
    links: 'ss-a11y-highlight-links',
    font: 'ss-a11y-readable-font',
    motion: 'ss-a11y-reduce-motion',
    focus: 'ss-a11y-focus',
  };
  const labels = {
    text: 'הגדלת טקסט',
    contrast: 'ניגודיות גבוהה',
    links: 'הדגשת קישורים',
    font: 'גופן קריא',
    motion: 'עצירת אנימציות',
    focus: 'הבלטת מיקוד',
  };

  let preferences = { ...defaults };
  let pausedAnimations = [];

  try {
    preferences = { ...defaults, ...JSON.parse(localStorage.getItem(storageKey) || '{}') };
  } catch (error) {
    preferences = { ...defaults };
  }

  const announce = (message) => {
    liveRegion.textContent = '';
    window.setTimeout(() => {
      liveRegion.textContent = message;
    }, 30);
  };

  const save = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(preferences));
    } catch (error) {
      // Preferences still work for the current page when storage is unavailable.
    }
  };

  const setMotion = (enabled) => {
    if (enabled) {
      if (typeof document.getAnimations === 'function') {
        pausedAnimations = document.getAnimations().filter((animation) => animation.playState === 'running');
        pausedAnimations.forEach((animation) => animation.pause());
      }

      document.querySelectorAll('video, audio').forEach((media) => {
        if (!media.paused) {
          media.dataset.ssA11yWasPlaying = 'true';
          media.pause();
        }
      });
      return;
    }

    pausedAnimations.forEach((animation) => {
      try {
        animation.play();
      } catch (error) {
        // Ignore animations removed from the document.
      }
    });
    pausedAnimations = [];

    document.querySelectorAll('[data-ss-a11y-was-playing="true"]').forEach((media) => {
      delete media.dataset.ssA11yWasPlaying;
      const playPromise = media.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    });
  };

  const applySetting = (setting, enabled, shouldAnnounce = false) => {
    preferences[setting] = enabled;
    root.classList.toggle(classNames[setting], enabled);

    const button = widget.querySelector(`[data-ss-a11y-setting="${setting}"]`);
    if (button) button.setAttribute('aria-pressed', String(enabled));
    if (setting === 'motion') setMotion(enabled);

    if (shouldAnnounce) announce(`${labels[setting]} ${enabled ? 'הופעל' : 'בוטל'}`);
  };

  const setOpen = (open, returnFocus = false) => {
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'סגירת כלי נגישות' : 'פתיחת כלי נגישות');

    if (open) {
      closeButton.focus();
    } else if (returnFocus) {
      trigger.focus();
    }
  };

  Object.keys(defaults).forEach((setting) => applySetting(setting, Boolean(preferences[setting])));

  trigger.addEventListener('click', () => {
    setOpen(trigger.getAttribute('aria-expanded') !== 'true');
  });

  closeButton.addEventListener('click', () => setOpen(false, true));

  settingButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const setting = button.dataset.ssA11ySetting;
      applySetting(setting, !preferences[setting], true);
      save();
    });
  });

  resetButton.addEventListener('click', () => {
    Object.keys(defaults).forEach((setting) => applySetting(setting, false));
    save();
    announce('כל הגדרות הנגישות אופסו');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
      setOpen(false, true);
    }
  });

  document.addEventListener('click', (event) => {
    if (trigger.getAttribute('aria-expanded') === 'true' && !widget.contains(event.target)) {
      setOpen(false);
    }
  });
})();
